// extracted by mini-css-extract-plugin
export default {"voicePrefernceParent":"ccf-voice-preference_voicePrefernceParent__QrrXO"};